/**
 * The DMP panel's copy of the server's document summary and artifact status
 * rule (docgen reasons, round 5). The web build cannot import functions/, so
 * dmpSectionSave.test.ts compares these with
 * functions/src/utils/sectionFailure.ts on the same inputs; a drift fails it.
 */

const FAILED_STATUSES = new Set(['generation_failed', 'failed']);

export function dmpDocumentSummary(sections: ReadonlyArray<{ id?: string; status?: string | null }>): {
  failedSectionIds: string[];
  failedSectionCount: number;
  generationStatus: 'complete' | 'incomplete';
} {
  const failed = (sections ?? []).filter((s) => FAILED_STATUSES.has(String(s?.status ?? '')));
  return {
    failedSectionIds: failed.map((s) => String(s?.id ?? '')),
    failedSectionCount: failed.length,
    generationStatus: failed.length > 0 ? 'incomplete' : 'complete',
  };
}

/**
 * The artifact status that should follow the document, or null to leave it
 * alone. Only "generated" and "incomplete" switch; approved, draft and every
 * other state are never touched.
 */
export function nextArtifactStatus(current: unknown, generationStatus: 'complete' | 'incomplete'): 'generated' | 'incomplete' | null {
  if (current !== 'generated' && current !== 'incomplete') return null;
  const next = generationStatus === 'complete' ? 'generated' : 'incomplete';
  return next === current ? null : next;
}
